import React from 'react';
import Chart from 'react-apexcharts';

const generateData = (count: number, yrange: { min: number; max: number }) => {
  let i = 0;
  const series = [];
  while (i < count) {
    const x = `w${(i + 1).toString()}`;
    const y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    series.push({
      x,
      y,
    });
    i++;
  }
  return series;
};

const data = [
  {
    name: 'DoD',
    data: generateData(12, { min: 0, max: 90 }),
  },
  {
    name: 'DHS',
    data: generateData(12, { min: 0, max: 90 }),
  },
  {
    name: 'HHS',
    data: generateData(12, { min: 0, max: 90 }),
  },
  {
    name: 'DOE',
    data: generateData(12, { min: 0, max: 90 }),
  },
];

const options = {
  chart: {
    type: 'heatmap',
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  colors: ['#8884d8'],
  title: {
    text: 'Win Rate by Agency and Week',
    style: {
      fontSize: '14px',
      fontWeight: 500,
    },
  },
  plotOptions: {
    heatmap: {
      shadeIntensity: 0.5,
      radius: 0,
      colorScale: {
        ranges: [
          { from: 0, to: 30, name: 'low', color: '#FFB1C1' },
          { from: 31, to: 60, name: 'medium', color: '#FF9F9F' },
          { from: 61, to: 90, name: 'high', color: '#FF7171' },
        ],
      },
    },
  },
  xaxis: {
    type: 'category',
  },
};

export function WinRateHeatmap() {
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="text-lg font-medium text-gray-900">Win Rate Analysis</h3>
      <div className="mt-2">
        <div className="h-[300px]">
          <Chart
            options={options}
            series={data}
            type="heatmap"
            height={300}
          />
        </div>
      </div>
    </div>
  );
}